import { MunicipioModel, UnidadeFederacaoModel } from '../../../shared/index';

export class InstituicaoModel {

    public escolaId: number;
    public cnpjBase: string;
    public cnpjFilial: string;
    public cnpjDigito: number;
    public areaParticipacaoId: number;
    public nome: string;
    public logradouro: string;
    public numeroEndereco: string;
    public complementoEndereco: string;
    public bairro: string;
    public cep: number;
    public dddTelefone: string;
    public telefone: string;
    public dddFax: string;
    public fax: string;
    public codigoSituacaoInstituicao: number;
    public codigoTipoLogradouro: string;
    public municipioId: number;
    public unidadeFederacaoId: string;
    public dataPublicacao: string;
    public dataAssinaturaDirigente: string;
    public dataFimVigencia;
    public quantidadeIndicacoesEtapa: number;
    public quantidadeIndicacoesAtual: number;
    public quantidadeNotasFiscais: number;
    public municipio: MunicipioModel;
    public unidadeFederacao: UnidadeFederacaoModel;

    constructor(nome: string,
                areaParticipacaoId: number,
                cnpjBase: string,
                cnpjDigito: number,
                municipio: MunicipioModel) {
        this.nome = nome;
        this.areaParticipacaoId = areaParticipacaoId;
        this.cnpjBase = cnpjBase;
        this.cnpjDigito = cnpjDigito;
        this.municipio = municipio;
    }
}



// WEBPACK FOOTER //
// ./src/app/restrito/instituicao/shared/instituicao.model.ts